module.exports = __webpack_public_path__ + "img/reccomend-partner.a20b4fd6.svg";